<template>
  <div class="container">
    <img src="static/img/fytop.png" style="width: 100%" alt="" />
    <div class="share" v-if="isapp" @click="share()">分享</div>
    <div class="main" style="padding-bottom: 50px">
      <p style="margin-bottom: 20px; font-weight: bold">专栏服务</p>
      <div
        style="padding: 16px; background: #f2f2f2; border-radius: 16px"
        class="flex"
      >
        <div>
          <div
            class="circle"
            style="
              background: linear-gradient(133deg, #c2adff 0%, #7a62fb 100%);
            "
            @click="$router.push('/yqfktg')"
          >
            最新通告
          </div>
        </div>
        <div>
          <div
            class="circle"
            style="
              background: linear-gradient(133deg, #ff9954 0%, #fc6f3d 100%);
            "
            @click="$router.push('/fyzx')"
          >
            防疫资讯
          </div>
        </div>
        <div>
          <div
            class="circle"
            style="
              background: linear-gradient(133deg, #7fc4f9 0%, #5dabf8 100%);
            "
            @click="linkto('fkqwzcg')"
          >
            <p>
              封控区<br />
              物资采购
            </p>
          </div>
        </div>
        <div>
          <div
            class="circle"
            style="
              background: linear-gradient(135deg, #ffd67d 0%, #fda749 100%);
            "
            @click="$router.push('fykp')"
          >
            防疫科普
          </div>
        </div>
        <div>
          <div
            class="circle"
            style="
              background: linear-gradient(133deg, #ff9954 0%, #fc6f3d 100%);
            "
            @click="$router.push('/fyxlyz')"
          >
            心理援助
          </div>
        </div>
        <div>
          <div
            class="circle"
            style="
              background: linear-gradient(133deg, #c2adff 0%, #7a62fb 100%);
            "
            @click="$router.push('fybgt')"
          >
            曝光台
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "fangyi",
  data() {
    return {
      appId: "2312",
      url: "//zhuzhan.ijiangyin.com/siteapp/appClient/sign",
      isapp: false,
    };
  },
  created() {
    var browser = {
      versions: (function () {
        var u = navigator.userAgent;
        return {
          trident: u.indexOf("Trident") > -1,
          presto: u.indexOf("Presto") > -1,
          webKit: u.indexOf("AppleWebKit") > -1,
          gecko: u.indexOf("Gecko") > -1 && u.indexOf("KHTML") == -1,
          mobile: !!u.match(/AppleWebKit.*Mobile.*/),
          ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/),
          android: u.indexOf("Android") > -1 || u.indexOf("Linux") > -1,
          iPhone: u.indexOf("iPhone") > -1,
          iPad: u.indexOf("iPad") > -1,
          webApp: u.indexOf("Safari") == -1,
          uc:
            (u.indexOf("Android") > -1 || u.indexOf("Linux") > -1) &&
            u.indexOf("UCBrowser") > -1,
          weixin: u.toLowerCase().match(/MicroMessenger/i) == "micromessenger", //判断微信
          iosApp: u.match(/ByIphone/i) != null, //判断ios版app
          androidApp: u.match(/ByAndroid/i) != null, //判断android版app
          iPhoneOs:
            u.indexOf("iPhone") > -1 && u.indexOf("Mobile") > -1
              ? /CPU (?:iPhone )?OS (\d+_\d+)/.test(u)
                ? parseFloat(RegExp.$1.replace("_", "."))
                : 2
              : null, //返回ios版本号
        };
      })(),
    };
    if (!browser.versions.iosApp && !browser.versions.androidApp) {
      //如果不在app中打开
      console.log("未在APP中打开");
      this.isapp = false;
    } else {
      this.isapp = true;
      this.zjyinit();
    }
  },
  methods: {
    zjyinit() {
      var that = this;
      zjyapi.init({
        appId: that.appId,
        error: function (code, ret) {
          //失败回调,默认
          alert("初始化失败");
        },
        success: function success(ret) {},
      });
    },
    //app相关开始
    //获取签名方法
    getSign: function (fun) {
      /*请求参数*/
      var paramObj = {
        httpUrl: this.url,
        type: "post",
        data: {
          appId: this.appId,
        },
      };
      /*请求调用*/
      this.httpRequest(paramObj, fun, function () {
        alert("获取签名失败错误");
      });
    },
    httpRequest: function (paramObj, fun, errFun) {
      var xmlhttp = null;
      /*创建XMLHttpRequest对象，
       *老版本的 Internet Explorer（IE5 和 IE6）使用 ActiveX 对象：new ActiveXObject("Microsoft.XMLHTTP")
       * */
      if (window.XMLHttpRequest) {
        xmlhttp = new XMLHttpRequest();
      } else if (window.ActiveXObject) {
        xmlhttp = new ActiveXObject("Microsoft.XMLHTTP");
      }
      /*判断是否支持请求*/
      if (xmlhttp == null) {
        alert("你的浏览器不支持XMLHttp");
        return;
      }
      /*请求方式，并且转换为大写*/
      var httpType = (paramObj.type || "GET").toUpperCase();
      /*数据类型*/
      var dataType = paramObj.dataType || "json";
      /*请求接口*/
      var httpUrl = paramObj.httpUrl || "";
      /*是否异步请求*/
      var async = paramObj.async || true;
      /*请求参数--post请求参数格式为：foo=bar&lorem=ipsum*/
      var paramData = paramObj.data || [];
      var requestData = "";
      for (var name in paramData) {
        requestData += name + "=" + paramData[name] + "&";
      }
      requestData =
        requestData == ""
          ? ""
          : requestData.substring(0, requestData.length - 1);
      console.log(requestData);
      /*请求接收*/
      xmlhttp.onreadystatechange = function () {
        if (xmlhttp.readyState == 4 && xmlhttp.status == 200) {
          /*成功回调函数*/
          //获取签名数据成功:{"serverTime":null,"error":"200","msg":"成功","data":{"appSign":"b37808616bda9d71e100e0971881101d","appId":"2312""timestamp":1575953679723},"map":null}
          console.log("获取签名数据成功:" + xmlhttp.responseText);
          var obj = JSON.parse(xmlhttp.responseText);
          var data = obj.data;
          fun({
            timestamp: data.timestamp,
            sign: data.appSign,
          });
        } else {
          /*失败回调函数*/
          errFun;
        }
      };
      /*接口连接，先判断连接类型是post还是get*/
      if (httpType == "GET") {
        xmlhttp.open("GET", httpUrl, async);
        xmlhttp.send(null);
      } else if (httpType == "POST") {
        xmlhttp.open("POST", httpUrl, async);
        //发送合适的请求头信息
        xmlhttp.setRequestHeader(
          "Content-type",
          "application/x-www-form-urlencoded"
        );
        xmlhttp.send(requestData);
      }
    },
    linkto(url) {
      switch (url) {
        case "fkqwzcg":
          location.href = "http://wx2.ijiangyin.com/h5/wzcg/index.html#/";
          break;
        default:
          break;
      }
    },
    share() {
      var that = this;
      this.getSign(function (sign) {
        zjyapi.openShare({
          params: {
            title: "疫情“解忧杂货铺”",
            content: "疫情“解忧杂货铺”",
            url: "https://www.jywmsj.cn/h5/#/fangyi", //分享地址
            imgUrl:
              "https://pic-cdn.bigdatajy.com/wenming/static/img/fytop.png", //分享图标地址
          },
          sign: sign, //获取调用签名
          success: function (ret) {
            console.log("调用分享-成功返回:" + JSON.stringify(ret));
          },
          error: function (error) {
            console.log("调用分享-调用失败:" + JSON.stringify(error));
          },
        });
      });
    },
  },
};
</script>
<style scoped>
.container {
  min-height: 100vh;
  background: #f2f2f2;
}
.main {
  position: relative;
  margin: 0 16px;
  margin-top: -12vw;
  background: white;
  border-radius: 16px;
  padding: 16px;
}
.flex {
  display: flex;
  flex-wrap: wrap;
}
.flex > div {
  width: 50%;
  margin: 20px 0;
}
.circle {
  width: 22vw;
  height: 22vw;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  margin: 0 auto;
  text-align: center;
  font-weight: bold;
}
.share {
  padding: 2px 10px;
  border-radius: 30px 0 0 30px;
  color: #58b3f1;
  background: white;
  position: absolute;
  top: 10px;
  right: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/fangyi.vue